'use strict';

module.exports = require('./google-analytics');


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-beacon/targets/google-analytics/index.js
// module id = 996
// module chunks = 157